export enum ResetPasswordError {
  InvalidId = 'Invalid Id',
  Throttled = '<b>This request have been throttled!</b><br>Please try again.',
  PasswordWeak = '<b>Password is to weak!</b><br>At least one number, one lowercase and one uppercase letter. At least eight characters that are letters, numbers or the underscore',
  CouldNotUpdate = '<b>Could not update key or password!</b><br>Please try again.',
  InvalidKeyOrPassword = '<b>Invalid key or password!</b><br>Please try again.',
}
